module.exports = __webpack_public_path__ + "static/media/freight.03f508b2.jpg";